import * as types from './actionTypes';

export function contractsSet(contracts: any) {
  return { type: types.CONTRACTS_SET, contracts };
}
